import { render, staticRenderFns } from "./reset-my-password.vue?vue&type=template&id=142b6f8c&"
import script from "./reset-my-password.vue?vue&type=script&lang=js&"
export * from "./reset-my-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports